import React, { useState, useEffect } from "react";
import "./nav.css";
import logo from "../../assets/logo.png";
import { connectWallet, getCurrentWalletConnected } from "../../utils/interact";
import { GiHamburgerMenu } from "react-icons/gi";
import { AiOutlineClose } from "react-icons/ai";
import { Link } from "react-router-dom";

const Nav = () => {
  const [nav, setNav] = useState(false); // the default state of the nav is closed hence false
  const [status, setStatus] = useState("");
  const [walletAddress, setWallet] = useState("");

  useEffect(() => {
    async function loadCurrentWalletConnected() {
      const { address, status } = await getCurrentWalletConnected();
      console.log(status);
      if (status === "🦊 Connect to Metamask using the top right button.") {
        handleconnectWallet();
      } else {
        setWallet(address);
        setStatus(status);
        addWalletListener();
      }
    }
    loadCurrentWalletConnected();
    console.log(walletAddress);
  }, []);
  const handleconnectWallet = async () => {
    const walletResponse = await connectWallet();
    if (walletResponse.type === false) {
      alert(walletResponse.status);
    } else {
      setStatus(walletResponse.status);
      setWallet(walletResponse.address);
    }
  };

  const addWalletListener = async () => {
    if (window.ethereum) {
      window.ethereum.on("accountsChanged", (accounts) => {
        if (accounts.length > 0) {
          setWallet(accounts[0]);
          setStatus("👆🏽 Write a message in the text-field above.");
        } else {
          setWallet("");
          setStatus("🦊 Connect to Metamask using the top right button.");
        }
      });
    } else {
      setStatus(
        <p>
          {" "}
          🦊{" "}
          <a
            target="_blank"
            rel="noreferrer"
            href={`https://metamask.io/download.html`}
          >
            You must install Metamask, a virtual Ethereum wallet, in your
            browser.{" "}
          </a>{" "}
        </p>
      );
    }
  };

  return (
    <nav className="container nav_container">
      <div className="nav_logo">
        <img
          className="nav_logo-image"
          src={logo}
          alt="logo"
          // style={{
          //   width: "90px",
          //   height: "inherit",
          // }}
        />
      </div>
      <div className="nav_items">
        <ul className="nav-list">
          <li className="nav_list-item">
            <a href="/#about">
              <span>About</span>
            </a>
          </li>
          <li className="nav_list-item">
            <a href="/#nftproject">
              <span>Collection</span>
            </a>
          </li>
          <li className="nav_list-item">
            <a href="/#roadmap">
              <span>Roadmap</span>
            </a>
          </li>
          <li className="nav_list-item">
            <a href="/#help">
              <span>Help / FAQs </span>
            </a>
          </li>
          <li className="nav_list-item">
            <Link to="/monkedoos">
              <span>MonkeyDoo's</span>
            </Link>
          </li>
          <li className="nav_list-item">
            <a href="https://marketplace.monkeydoonft.com/" target="_blank">
              <span>Marketplace</span>
            </a>
          </li>
          <li className="nav_list-item">
            <a href="https://eth.monkeydoonft.com/" target="_blank">
              <span>Visit MonkeyDoo 3D ETH</span>
            </a>
          </li>
          <li className="nav_list-item">
            <Link to="/comic">
              <span>Mint Comic</span>
            </Link>
          </li>
          <div
            style={{
              padding: "9px",
            }}
          >
            <a href="https://t.me/MonkeyDoo_NFT" target="_blank">
              <i
                className="fa fa-telegram"
                style={{
                  color: "#ff779b",
                  fontSize: "25px",
                  margin: "5px",
                }}
              ></i>
            </a>
            <a
              href="https://twitter.com/MonkeyDoo_NFT?t=YtUCLKwoeuqsy5GUxIxxtQ&s=09"
              target="_blank"
            >
              <i
                className="fa fa-twitter"
                style={{
                  color: "#ff779b",
                  fontSize: "25px",
                  margin: "5px",
                }}
              ></i>
            </a>

            <a href="https://discord.gg/UhZFZHYwNx" target="_blank">
              <i
                className="fa fa-discord"
                style={{
                  color: "#ff779b",
                  fontSize: "25px",
                  margin: "5px",
                }}
              ></i>
            </a>
          </div>
        </ul>
        <div className="nav_profile">
          {walletAddress === "" ? (
            <a>
              <button
                className="btn btn-primary"
                style={{
                  marginTop: "20px",
                }}
                onClick={handleconnectWallet}
              >
                Connect Wallet
              </button>
            </a>
          ) : (
            <Link
              to="/wallet"
              style={{
                marginTop: "20px",
              }}
            >
              <button className="btn btn-primary">My Wallet</button>
            </Link>
          )}
        </div>
      </div>
      <div className="menu_bar">
        {walletAddress === "" ? (
          <a>
            <button
              className="btn btn-primary"
              style={{
                marginTop: "20px",
              }}
              onClick={handleconnectWallet}
            >
              Connect Wallet
            </button>
          </a>
        ) : (
          <Link
            to="/wallet"
            style={{
              marginRight: "20px",
            }}
          >
            <button className="btn btn-primary">My Wallet</button>
          </Link>
        )}
        <GiHamburgerMenu onClick={() => setNav(true)} />
        {nav ? (
          <div
            className="mobile_nav"
            // style={{
            //   transform: `${
            //     nav === true ? "translateX(0)" : "translateX(100%)"
            //   }`,
            // }}
          >
            <div className="close_wrapper">
              <AiOutlineClose onClick={() => setNav(false)} />
            </div>
            <ul>
              <li>
                <a href="/#about">About</a>
              </li>
              <li>
                <a href="/#nftproject">Collection</a>
              </li>
              <li>
                <a href="/#roadmap">Roadmap</a>
              </li>
              <li>
                <a href="/#help">Help/Faqs</a>
              </li>
              <li>
                <Link to="/monkedoos">MonkeyDoo's</Link>
              </li>
              <li>
                <Link to="/wallet">My Wallet</Link>
              </li>
              <li>
                <a href="https://marketplace.monkeydoonft.com/" target="_blank">
                  <span>Marketplace</span>
                </a>
              </li>
              <li>
                <Link to="/comic">
                  <span>Mint Comic</span>
                </Link>
              </li>
              <div
                style={{
                  textAlign: "center",
                }}
              >
                <a href="https://t.me/MonkeyDoo_NFT" target="_blank">
                  <i
                    className="fa fa-telegram"
                    style={{
                      color: "#fff",
                      fontSize: "35px",
                      margin: "5px",
                    }}
                  ></i>
                </a>
                <a
                  href="https://twitter.com/MonkeyDoo_NFT?t=YtUCLKwoeuqsy5GUxIxxtQ&s=09"
                  target="_blank"
                >
                  <i
                    className="fa fa-twitter"
                    style={{
                      color: "#fff",
                      fontSize: "35px",
                      margin: "5px",
                    }}
                  ></i>
                </a>
                <a href="https://discord.gg/UhZFZHYwNx" target="_blank">
                  <i
                    className="fa fa-discord"
                    style={{
                      color: "#fff",
                      fontSize: "35px",
                      margin: "5px",
                    }}
                  ></i>
                </a>
              </div>
              <button className="btn btn-primary mobile">Mint</button>
            </ul>
          </div>
        ) : null}
      </div>
    </nav>
  );
};

export default Nav;
